export const isLinkedInApp = () => {
  const ua = navigator.userAgent || navigator.vendor
  return ua.includes('LinkedInApp')
}
